import { IGroup } from 'parent-portal/group/models';
import React from 'react';
import { Text, TextButton } from 'library';
import { useHistory } from 'react-router-dom';
import { isLoggedIn } from 'api/UserApi';
import { Grid } from '@material-ui/core';
import { track } from 'shared';

export default function GroupInfo({ group }: { group: IGroup }) {
    const history = useHistory();

    function onPress() {
        track('Groups: Go to group page', { public: !isLoggedIn(), group: group?.name });
        isLoggedIn() ? history.push(`/group/${group.id}`) : history.push(`/public/group/${group.id}`);
    }
    return (
        <>
            <Grid item style={{ alignSelf: 'flex-start' }}>
                <TextButton
                    textStyle={{
                        fontStyle: 'h2',
                        fontWeight: 'bold',
                    }}
                    buttonStyle={{ alignItems: 'flex-start' }}
                    onClick={onPress}
                >
                    {group?.name}
                </TextButton>
            </Grid>
            <Text textStyle={{ padding: 0 }} bold variant="deprecatedCaption">
                {group.member_count} members
            </Text>
            <Text textStyle={{ padding: 0, fontStyle: 'italic' }} variant="deprecatedCaption">
                Last active {Math.floor(Math.random() * (23 - 2 + 1) + 2)} hours ago
            </Text>
        </>
    );
}
